/** @format */

import React, { useCallback } from 'react';
import Alert from 'components/V2/Alert';
import { types } from 'components/V2/Button';
import { useModal } from 'modules/ui';
import { useHistory, useLocation } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { getLocalStorageLng } from 'utils/utils';
import post_secret from '../../../../images/img/post_secret.svg';

const AlertModal = () => {
	const { alertModal } = useModal();
	const history = useHistory();
	const localizedLang = getLocalStorageLng();
	const location = useLocation();

	const gotoPostList = useCallback(() => {
		if (location.pathname !== `/${localizedLang}/posts`) {
			history.push(`/${localizedLang}/posts`);
		}
	}, [localizedLang, location.pathname]);

	if (!alertModal.isOpen) {
		return null;
	}

	switch (alertModal.type) {
		case 'PRIVATE_POST': {
			return (
				<Alert
					image={post_secret}
					background="linear-gradient(180deg, #FFF952 0%, #FFE500 100%)"
					title={
						<>
							<Trans i18nKey="privatePostModal.title" />
							<br />
							<br />
							<Trans i18nKey="privatePostModal.title2" />
							<br />
							<Trans i18nKey="privatePostModal.title3" />
						</>
					}
					content={
						<>
							<ul>
								<li>
									<Trans i18nKey="privatePostModal.content1" />
								</li>
								<li>
									<Trans i18nKey="privatePostModal.content2" />
								</li>
								<li>
									<Trans i18nKey="privatePostModal.content3" />
								</li>
								<li>
									<Trans i18nKey="privatePostModal.content4" />
								</li>
							</ul>
						</>
					}
					buttons={[
						{
							color: types.supportThrough,
							text: 'App Store',
							url: 'https://apps.apple.com/tw/app/id1121788143'
						},
						{
							color: types.supportThrough,
							text: 'Google Play',
							url:
								'https://play.google.com/store/apps/details?id=com.eatme.eatgether&hl=zh-TW'
						}
					]}
					footer={<Trans i18nKey="privatePostModal.footer" />}
					close={<Trans i18nKey="privatePostModal.closeButton" />}
					onClose={gotoPostList}
				/>
			);
		}
	}
};

export default React.memo(AlertModal);
